/* global grecaptcha */

import { waitForGlobal } from '../utils/scriptLoader'
import BaseDriver from './BaseDriver'

/**
 * RecaptchaV2Driver - Handles reCAPTCHA v2 (visible checkbox)
 */
class RecaptchaV2Driver extends BaseDriver {
  async waitForLibrary() {
    await waitForGlobal('grecaptcha', 'render', 30000)
  }

  // noinspection JSCheckFunctionSignatures
  async getToken(action, options = {}) {
    return this.getRenderedToken(options.container)
  }

  watchForElements(container) {
    // Initialize existing elements
    const elements = container.querySelectorAll('.g-recaptcha')
    elements.forEach((el) => this.renderElement(el))

    // Watch for new elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const els = node.querySelectorAll?.('.g-recaptcha')
            els?.forEach((el) => this.renderElement(el))
          }
        })
      })
    })

    observer.observe(container, {
      childList: true,
      subtree: true,
    })
  }

  renderElement(element) {
    if (element.children.length > 0) {
      return // Already rendered
    }

    grecaptcha.render(element, {
      sitekey: element.getAttribute('data-sitekey') || this.publicKey,
      theme: element.getAttribute('data-theme') || 'light',
      size: element.getAttribute('data-size') || 'normal',
    })
  }
}

export default RecaptchaV2Driver
